import io from 'socket.io-client';

type AppSocket = ReturnType<typeof io>;

let socketRef: AppSocket | null = null;

/** Called by SocketContext when the shared socket connects or disconnects. */
export function bindCommunitySocket(socket: AppSocket | null): void {
  socketRef = socket;
}

export function getSocket(): AppSocket | null {
  return socketRef;
}

export function emitTyping(groupId: string, userId: string, displayName?: string): void {
  const socket = getSocket();
  if (socket?.connected) {
    socket.emit('community:typing', {
      group_id: groupId,
      user_id: userId,
      client_id: userId,
      display_name: displayName,
    });
  }
}

export function emitStopTyping(groupId: string, userId: string): void {
  const socket = getSocket();
  if (socket?.connected) {
    socket.emit('community:stopTyping', {
      group_id: groupId,
      user_id: userId,
      client_id: userId,
    });
  }
}

export function joinCommunityRoom(communityId: string): void {
  const socket = getSocket();
  if (socket?.connected) {
    socket.emit('community:community:join', { community_id: communityId });
  }
}

export function joinGroupRoom(groupId: string): void {
  const socket = getSocket();
  if (!groupId) return;
  if (socket?.connected) {
    socket.emit('community:group:join', { group_id: groupId });
  }
}

export function leaveGroupRoom(groupId: string): void {
  const socket = getSocket();
  if (socket?.connected) {
    socket.emit('community:group:leave', { group_id: groupId });
  }
}
